<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import LocalizedInput from '@/components/LocalizedInput.vue';
import StandardInput from '@/components/StandardInput.vue';
import StandardToggle from '@/components/StandardToggle.vue';
import LocalizedEditor from '@/components/base/LocalizedEditor.vue';
import type { Locales, ProjectModuleDto } from '@/services/types/api.types';
import { useConfigurationStore } from '@/stores/configurations.store';

// CONST
const { t } = useI18n();
const isProjectTOCEnabled = useConfigurationStore().isFeatureEnabled('projectTOC');

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
  editLocale: Locales;
  module: ProjectModuleDto;
}>();
</script>
<template>
  <div class="module-comments">
    <localized-input
      name="title"
      :label="t('global.label.title')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <q-field :label="t('global.label.description')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.description"
          :label="t('global.label.description')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="props.languageEnabled"
        />
      </template>
    </q-field>
    <q-field :label="t('global.label.thank-you-message')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.thankYouMessage"
          :label="t('global.label.thank-you-message')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="props.languageEnabled"
        />
      </template>
    </q-field>
    <standard-input
      name="config.maxLength"
      :label="t('project-module.feedback.max-length')"
      type="number"
      outlined
      :min="1"
      :clearable="true"
    />
    <standard-toggle name="config.highlight" :label="t('project-module.admin.highlight')" outlined />
    <standard-toggle
      v-if="isProjectTOCEnabled"
      name="config.includeInTableOfContents"
      :label="t('project-module.admin.includeInTableOfContents')"
      outlined
    />
    <standard-toggle
      name="config.anonymousFeedback"
      :label="t('project-module.feedback.anonymous-feedback')"
      outlined
    />
    <standard-toggle
      name="config.requiresModeration"
      :label="t('project-module.feedback.requires-moderation')"
      outlined
    />
  </div>
</template>
